import guard from '../guard.js';

const generateGuardedColor = (color, fixedPointDigits) => guard(0, 255, color).toFixed(fixedPointDigits);
function rgba(red, green, blue, alpha) {
  const guardedRed = generateGuardedColor(red);
  const guardedGreen = generateGuardedColor(green);
  const guardedBlue = generateGuardedColor(blue);
  const guardedAlpha = generateGuardedColor(alpha, 3);
  return `rgba(${guardedRed}, ${guardedGreen}, ${guardedBlue}, ${parseFloat(
    guardedAlpha
  )})`;
}

export { rgba as default };
